import { useResetEmailPresenter } from '../../presenter'
import { EmailGoThroughPage } from '../../ui-kit'

export const ResetEmail = () => <EmailGoThroughPage {...useResetEmailPresenter()} buttonText="Continue" />
